import React, { useState, useEffect } from "react";
import "./statistics.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Cell
} from "recharts";

const colors = ["#54749b","#002b5b", "#3d536b","#4b7cb6"];
/* ---------- Placement Data ---------- */
const placementData = {
  "2024-25": [
    { name: "B.Tech Marine", value: 91.76 },
    { name: "B.Sc Nautical", value: 90 },
    { name: "DNS", value: 100 },
    { name: "ETO", value: 76.92 },
  ],
    "2023-24": [
    { name: "B.Tech Marine", value: 95.23 },
    { name: "B.Sc Nautical", value: 90.9 },
    { name: "DNS", value: null },
    { name: "ETO", value: null },
  ],
    "2022-23": [
    { name: "B.Tech Marine", value: 92 },
    { name: "B.Sc Nautical", value: 90.9 },
    { name: "DNS", value: null },
    { name: "ETO", value: null },
  ],
  "2021-22": [
    { name: "B.Tech Marine", value: 96.92 },
    { name: "B.Sc Nautical", value: 100 },
    { name: "DNS", value: null },
    { name: "ETO", value: null },
  ],
    "2020-21": [
    { name: "B.Tech Marine", value: 100 },
    { name: "B.Sc Nautical", value: 100 },
    { name: "DNS", value: null },
    { name: "ETO", value: null },
  ],

};

const Statistics = () => {

  
  const [selectedYear, setSelectedYear] = useState("2024-25");
  const [barSize, setBarSize] = useState(100); // default desktop
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width <= 480) {
        setBarSize(45); // small mobile
      } else if (width <= 768) {
        setBarSize(65); // tablet
      } else if (width <= 1040) {
        setBarSize(75); // tablet
      } else {
        setBarSize(100); // desktop
      }
    };

    handleResize(); // initial call
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div>
      <h1 className="title">Placement Statistics</h1>
      <hr />

      <div className="page-content-container">
        <div className="statistics-top">
          <h4 className="statistics-title">
            100% Placement Assistance For On Campus & Off Campus Placements.
          </h4>

          {/* Year Dropdown */}
          <div className="year-container">
            <label className="statistics-year">Select Year:</label>
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="year-dropdown"
            >
              {Object.keys(placementData).map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* ---------- Bar Chart ---------- */}

<div className="chart-wrapper">
  <ResponsiveContainer>
    <BarChart
      data={placementData[selectedYear]}
      margin={{ top: 25, right: 20, left: 0, bottom: 60 }}
    >
      <CartesianGrid strokeDasharray="3 3" />

      <XAxis
        dataKey="name"
        interval={0}
        angle={isMobile ? -30 : 0}
        textAnchor={isMobile ? "end" : "middle"}
        height={isMobile ? 70 : 50}
      />

      <YAxis domain={[0, 100]} unit="%" />

      <Tooltip formatter={(val) => (val !== null ? `${val}%` : "NA")} />

      <Bar
        dataKey="value"
        barSize={barSize}
        background={{ fill: "#e6e6e6" }}
        label={{
          position: "top",
          formatter: (v) => (v !== null ? `${v}%` : ""),
        }}
      >
        {placementData[selectedYear].map((entry, index) => (
          <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
        ))}
      </Bar>

    </BarChart>
  </ResponsiveContainer>
</div>
      </div>
    </div>
  );
};

export default Statistics;

